<template>
  <div :id="parte_key" class="tab-detalle has-text-left" v-if="this.colores !== null">
    <h3 class="has-text-weight-bold is-red is-uppercase">{{ parte_key =='modelos' ? this.$i18n.t('general.carenado') : this.$i18n.t('general.'+parte_key) }}<small>{{seleccionado}}</small></h3>
    <div class="scrolling-wrapper" v-show="opciones && opciones.length > 0">
      <div class="opcion" v-for="(opcion) in lopciones" :key="'op_'+parte_key+'_'+opcion.nombre" :class="{opcion: true, selected: selected_opcion !== null ? selected_opcion == opcion.codigo : opcion.selected }">
        <b-button @click="selOpcion(opcion)">{{ opcion.nombre }}</b-button>
      </div>
    </div>
    <p></p>
    <div v-if="parte && parte.hasOwnProperty('es_array') && parte.opciones.length > 0">
      <b-field v-for="opcion in parte.opciones" :key="'op_'+parte_key+'_'+opcion.codigo" >

        <b-radio  v-model="selected_opcion"
                  :native-value="opcion.codigo"
                  type="is-primary"
                  :disabled="!parte.obligatorio"
                  @click.native="selOpcion(opcion.codigo)"

        >

          {{ opcion.nombre[lang.replace('_','-').toLowerCase()] }}

        </b-radio>
      </b-field>
    </div>



    <div v-if="!this.$store.getters.getPartesOcultas.some(e => e ==='carenado-posterior' && e==='modelos') && (this.parte_key=='modelos') && !esversionpublica">
      <p class="is-size-6 mt-2">{{ this.$i18n.t('general.ClickSelectColor') }}</p>
      <div class="colores has-text-left">
        <b-button :type="'is-'+selected_color_modelos" @click="activateModalColor('modelos')" v-if="!this.$store.getters.getPartesOcultas.some(e => e ==='modelos')">{{ selected_color_modelos }}</b-button>
        <p @click="activateModalColor('modelos')" class="with-help" v-if="!this.$store.getters.getPartesOcultas.some(e => e ==='modelos')">{{ selected_color_modelos }}<span><br /><em title="Color del carenado delantero central">{{ this.$i18n.t('general.Central') }}</em></span></p>

        <b-button :type="'is-'+selected_color_carenado_posterior" @click="activateModalColor('carenado-posterior')" v-if="(typeof selected_color_carenado_posterior !=='undefined' && !this.$store.getters.getPartesOcultas.some(e => e ==='carenado-posterior')) || !esversionpublica">{{ selected_color_carenado_posterior }}</b-button>
        <p @click="activateModalColor('carenado-posterior')" class="with-help" v-if="!this.$store.getters.getPartesOcultas.some(e => e ==='carenado-posterior') || !esversionpublica">{{ selected_color_carenado_posterior }}<span><br /><em title="Color del carenado posterior">{{ this.$i18n.t('general.Posterior') }}</em></span></p>
      </div>
    </div>
    <div v-else-if="!this.$store.getters.getPartesOcultarSelector.some(e => e == this.parte_key) && !esversionpublica" >
      <p class="is-size-6 mt-2">{{ this.$i18n.t('general.ClickSelectColor') }}</p>
      <div class="colores has-text-left">
        <b-button :type="'is-'+selected_color" @click="activateModalColor(parte_key)" >{{ selected_color }}</b-button>
        <p @click="activateModalColor(parte_key)" class="with-help">{{ selected_color }}</p>


      </div>
    </div>

    <b-modal
        v-model="isColoresModalActive"
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        :aria-label="this.$i18n.t('general.ColorSelector')"
        aria-modal
        custom-class="selector-colores">
      <div class="card">
        <div class="card-content has-text-centered">
          <div class="content pb-2">
            <h4 class="is-size-5 has-text-weight-normal is-gris">{{ this.$i18n.t('general.SelectColor') }}</h4>
            <!--<a class="close has-text-right is-size-7">
              <span class="has-text-centered"><img svg-inline class="icon" src="../assets/img/icon-close.svg" alt="cerrar" /></span>
            </a>-->
            <div class="colores has-text-centered" v-if="especial_modelos==false && especial_carenado_posterior==false">
              <b-button  v-for="(color) in colores" :key="'color_'+color" :type="'is-'+color" @click="selColor(color)" :focused="color === selected_color">{{ color }}</b-button>
            </div>
            <div class="colores has-text-centered" v-if="especial_modelos==true">
              <b-button  v-for="(color) in colores" :key="'color_'+color" :type="'is-'+color" @click="selColor(color)" :focused="color === selected_color_modelos">{{ color }}</b-button>
            </div>
            <div class="colores has-text-centered" v-if="especial_carenado_posterior==true">
              <b-button   v-for="(color) in colores" :key="'color_'+color" :type="'is-'+color" @click="selColor(color)" :focused="color === selected_color_carenado_posterior">{{ color }}</b-button>
            </div>
            <b-button type="is-ghost" expanded class="py-4 is-size-5" @click="isColoresModalActive = false">{{ this.$i18n.t('general.Cancel') }}</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "selColorPartes",
  props: ['parte_key','parte','opciones','colores','defaultcolor','lang'],
  data (){
    return {
      isColoresModalActive: false,
      selected_opcion: null,
      selected_color: null,
      selected_color_modelos: null,
      selected_color_carenado_posterior: null,
      lopciones : null,
      emitir: false,
      especial_modelos: false,
      especial_carenado_posterior: false,
      choosingParte: null,
      esversionpublica: process.env.VUE_APP_ES_PUBLIC == 1 ? true : false,
      debugMode: process.env.VUE_APP_DEBUGMODE == 1 ? true : false
    }
  },
  computed: {

    seleccionado: function (){
      //return this.parte.hasOwnProperty('opciones') ? this.parte.opciones.find(v => v.default === true).codigo : ''
      //return this.parte.seleccionado
      return ''
    },
    variaciones: function () {
      return this.$store.getters.getVariaciones;
    },
    modelo: function () {
      return this.$store.getters.getModeloActivo;
    },
    storeColorConfig1() {
      return this.$store.getters.getColorConfig1
    },
    storeColorConfig2() {
      return this.$store.getters.getColorConfig2
    },
  },
  mounted() {

      this.setInitValues()



  },

  methods: {
    selOpcion(opcion){
      this.emitir=true;

      if (opcion !== this.selected_opcion){
        if (typeof  opcion == 'object'){
          this.selected_opcion = opcion.codigo
          if (this.parte_key=='modelos'){
            this.$emit('modelo-activo', opcion.codigo)
          }
        }else{
          this.selected_opcion = opcion
        }





        //this.opciones.forEach(op => { op.codigo != opcion.codigo ? op.selected = false : op.selected = true })


        //opcion.selected = true
        //console.log('Cambio opcion: '+ opcion)
        //console.log(opcion)
        /*
        if (this.selected_opcion !== null && typeof this.selected_opcion == 'string' ){
          this.opciones.forEach(op => { op.codigo != opcion ? op.selected = false : op.selected = true })
          //console.log('Cambio opcion: '+ opcion)
        }else{
          this.opciones.forEach(op => { op.codigo != opcion.codigo ? op.selected = false : op.selected = true })
          this.$emit('modelo-activo', opcion.codigo)
        }
        */


      }
    },
    selColor(color) {
      if (this.choosingParte=='modelos'){
        this.selected_color_modelos = color
      }else if (this.choosingParte=='carenado-posterior'){
        this.selected_color_carenado_posterior = color

      }else{
        this.selected_color = color
      }
      if (this.debugMode === true) console.log("selColor : "  + color)

      let selop = null

      if (this.selected_opcion !== null && typeof this.selected_opcion == 'string' ){
        selop = this.selected_opcion
      }else if (this.selected_opcion === null){
        selop = null
      }else{
        selop = this.selected_opcion.codigo
      }
      this.$store.commit('setSolicitar',true)
      if (this.choosingParte!=='carenado-posterior'){
        if (this.debugMode === true) console.log('Entro aqui !!!. No carenado posterior')
        this.$emit('registrar-cambio',{'parte': this.parte_key, cambio: 'color',valor:  color, opcion: selop})
      }
      else {
        this.$emit('registrar-cambio',{'parte': 'carenado-posterior', cambio: 'color',valor:  color, opcion: selop})
      }

      this.choosingParte=null
      this.isColoresModalActive = false
    },
    setInitValues(){

      this.emitir=false
      this.lopciones = this.opciones
      let color = null


      if (this.$store.getters.getActionToBackend == 'getConfigPuenteFromBackend'){
        //console.log('setInitValues: ' + this.parte_key+' selected_color: ' + this.selected_color)
        if (this.selected_color==null){

          if (this.defaultcolor){
            color = this.defaultcolor
          }else{
            if (this.parte_key == 'modelos'){
              if (this.$store.getters.getColorConfig1!==null){
                color = this.$store.getters.getColorConfig1
              }else{
                color =this.$store.getters.getPuenteLavadoActivo.modelos.find(v =>  v.default == true).partes.carenado.opciones.find(a => a.default==true).color

              }
              this.selected_color_modelos = color


              //this.selected_opcion = this.modelo

            }


              //this.selected_opcion = this.modelo



          }
          if (!color.startsWith('RAL') && !color.startsWith('PANT')){
            this.$store.dispatch('coloresRalToCodigo', color).then(val => {
              this.selected_color = val
              if (this.parte_key=='modelos'){
                this.selected_color_modelos = val
              }

              if (this.emitir===true){
                this.$emit('registrar-cambio',{'parte': this.parte_key, cambio: 'color',valor:  val})
              }

            })
          }

          //Inicializacion de valores para carenado posterior
          if(this.parte_key == 'modelos'){

            let color_carenado_posterior = color
            // Asignación temporal para evitar error
            color_carenado_posterior = this.$store.getters.getPuenteLavadoActivo.modelos.find(v =>  v.default == true).partes.carenado.opciones.find(a => a.default==true).color
            this.selected_color_carenado_posterior = color_carenado_posterior

            this.$store.dispatch('coloresRalToCodigo', color_carenado_posterior).then(val => {
              this.selected_color_carenado_posterior = val
              if (this.emitir===true){
                this.$emit('registrar-cambio',{'parte': 'carenado-posterior', cambio: 'color',valor:  val})
              }

            })
          }




        }
        this.selected_opcion = (this.parte !== null && 'opciones' in this.parte && this.parte.opciones.length > 0) ? this.parte.opciones.find(v => v.default === true).codigo : null
        if (this.parte_key === 'vinilo'){
          if (this.debugMode === true) console.log('*********** debug vinilo ***********' + JSON.stringify(this.parte))
        }{
          if (this.debugMode === true) console.log('*********** NO debug  ***********' + this.parte_key)
        }

        let objt = {
          'parte' : this.parte_key,
          'val' : this.selected_opcion
        }
        this.$store.commit('setParteSeleccionada',objt)
      }
      this.emitir=true;


    },
    activateModalColor(parte){
      this.choosingParte = parte;
      if (parte == 'modelos'){
        this.especial_modelos = true
        this.especial_carenado_posterior = false

      }else if (parte =='carenado-posterior') {
        this.especial_modelos = false
        this.especial_carenado_posterior=true
      }else{
        this.especial_modelos = false
        this.especial_carenado_posterior=false
      }

      this.isColoresModalActive = true

    }


  },
  watch: {
    parte : function () {
      this.setInitValues()

    },

    variaciones: function () {
      this.emitir=false
      if (typeof this.variaciones !=='undefined'){
        let v = this.variaciones.find(v => v.parte == this.parte_key && v.cambio == 'color')
        if (typeof v == 'object' && 'valor' in v){
          this.selected_color = v.valor
          if ('opcion' in v && v.opcion !== null) {
            if (this.selected_opcion==null){
              //console.log('Tiene opcion ('+ this.parte_key+') ' + v.opcion + ' selected_opcion: ' + this.selected_opcion)
              //this.selected_opcion = v.opcion
            }

          }


        }

        v = this.variaciones.find(v => v.parte == this.parte_key && v.cambio == 'opcion')
        if (typeof v == 'object' && 'valor' in v){
          this.selected_opcion = v.valor
          if ('opciones' in v){
            if ('color' in v.opciones){
              this.selected_color = v.opciones.color
            }

          }


        }

      }
    },

    selected_opcion: function (opcion){



        if (opcion !== null && typeof opcion == 'string' ){
          if (typeof this.opciones!=='undefined'){
            this.opciones.forEach(op => { op.codigo != opcion ? op.selected = false : op.selected = true })
          }
          if (this.emitir===true){
            let objt = {
              'parte' : this.parte_key,
              'val' : opcion
            }
            this.$store.commit('setSolicitar',true)
            this.$store.commit('setParteSeleccionada',objt)
            //console.log('selColorPartes Emite --> selected_opcion ('+this.emitir+'):' + opcion)
            this.$emit('registrar-cambio',{'parte': this.parte_key, cambio: 'opcion',valor: opcion, 'opciones': {'color': this.selected_color}})
          }


          //console.log('Cambio opcion: '+ opcion)
        }else{
          if (typeof this.opciones!=='undefined') {
            this.opciones.forEach(op => {
              op.codigo != opcion.codigo ? op.selected = false : op.selected = true
            })
          }
          if (this.emitir===true){

            this.$emit('modelo-activo', opcion.codigo)
          }

        }





    },

    storeColorConfig1: function(){
      this.selected_color_modelos = this.$store.getters.getColorConfig1
    },
    storeColorConfig2: function(){
      this.selected_color_carenado_posterior = this.$store.getters.getColorConfig2
    }
  }
}
</script>

<style scoped>

</style>
